// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PromotionsViewPromotionsHomeEvent
 */
export var PromotionsViewPromotionsHome = function () { return ({
    name: "Promotions View PromotionsHome",
    parameters: {
        cdf_entity: "Promotions",
        cdf_action: "View",
    }
}); };
/**
 * @see PromotionsViewPromotionRowEvent
 */
export var PromotionsViewPromotionRow = function (_a) {
    var campaignToken = _a.campaignToken, variantToken = _a.variantToken, promotionState = _a.promotionState;
    return ({
        name: "Promotions View PromotionRow",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "View",
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant_token: variantToken !== undefined && variantToken !== null ? variantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            promotion_state: promotionState !== undefined && promotionState !== null ? promotionState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsTapAddPromoCodeEvent
 */
export var PromotionsTapAddPromoCode = function (_a) {
    var source = _a.source;
    return ({
        name: "Promotions Tap AddPromoCode",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "Tap",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsTapInviteFriendsEvent
 */
export var PromotionsTapInviteFriends = function (_a) {
    var source = _a.source;
    return ({
        name: "Promotions Tap InviteFriends",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "Tap",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsTapPromotionRowEvent
 */
export var PromotionsTapPromotionRow = function (_a) {
    var campaignToken = _a.campaignToken, variantToken = _a.variantToken, promotionState = _a.promotionState;
    return ({
        name: "Promotions Tap PromotionRow",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "Tap",
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant_token: variantToken !== undefined && variantToken !== null ? variantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            promotion_state: promotionState !== undefined && promotionState !== null ? promotionState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsEnterCodeFailedEvent
 */
export var PromotionsEnterCodeFailed = function (_a) {
    var code = _a.code, codeType = _a.codeType, failureReason = _a.failureReason, codeManuallyEntered = _a.codeManuallyEntered, incentiveCampaignToken = _a.incentiveCampaignToken, incentiveCampaignVariantToken = _a.incentiveCampaignVariantToken;
    return ({
        name: "Promotions EnterCode Failed",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "EnterCode",
            code: code !== undefined && code !== null ? code.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            code_type: codeType !== undefined && codeType !== null ? codeType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            code_manually_entered: codeManuallyEntered !== undefined && codeManuallyEntered !== null ? codeManuallyEntered.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incentive_campaign_token: incentiveCampaignToken !== undefined && incentiveCampaignToken !== null ? incentiveCampaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incentive_campaign_variant_token: incentiveCampaignVariantToken !== undefined && incentiveCampaignVariantToken !== null ? incentiveCampaignVariantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsOptInSuccessEvent
 */
export var PromotionsOptInSuccess = function (_a) {
    var campaignToken = _a.campaignToken, campaignType = _a.campaignType, campaignName = _a.campaignName, variantToken = _a.variantToken, promoCode = _a.promoCode, campaignEndDate = _a.campaignEndDate, isMessageOnlyVariant = _a.isMessageOnlyVariant, rewardText = _a.rewardText;
    return ({
        name: "Promotions OptIn Success",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "OptIn",
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_type: campaignType !== undefined && campaignType !== null ? campaignType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_name: campaignName !== undefined && campaignName !== null ? campaignName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant_token: variantToken !== undefined && variantToken !== null ? variantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            promo_code: promoCode !== undefined && promoCode !== null ? promoCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_end_date: campaignEndDate !== undefined && campaignEndDate !== null ? campaignEndDate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_message_only_variant: isMessageOnlyVariant !== undefined && isMessageOnlyVariant !== null ? isMessageOnlyVariant.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reward_text: rewardText !== undefined && rewardText !== null ? rewardText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PromotionsOptInFailedEvent
 */
export var PromotionsOptInFailed = function (_a) {
    var failureReason = _a.failureReason, campaignToken = _a.campaignToken, variantToken = _a.variantToken, promoCode = _a.promoCode;
    return ({
        name: "Promotions OptIn Failed",
        parameters: {
            cdf_entity: "Promotions",
            cdf_action: "OptIn",
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            variant_token: variantToken !== undefined && variantToken !== null ? variantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            promo_code: promoCode !== undefined && promoCode !== null ? promoCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
